module.exports = __webpack_public_path__ + "static/media/crohns.c361f8e0.jpg";